export const useGoogleEventCard = () => {
  let json = [];
  const addEvent = (data) => {
    json.push({
      "@context": "https://schema.org",
      "@type": "Event",
      name: data.title,
      startDate: new Date(data.start).toISOString(),
      endDate: new Date(data.end).toISOString(),
      eventStatus: ["https://schema.org/EventScheduled"],
      eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
      image: [data.image],
      description: data.description,
      location: {
        "@type": "Place",
        name: data.place.name,
        address: {
          "@type": "PostalAddress",
          name: `${data.place.street}, ${data.place.city} ${data.place.postal}`,
        },
      },
    });
  };
  const resetEvents = () => {
    json = [];
  };
  return {
    json,
    addEvent,
    resetEvents,
  };
};
